module.exports = __webpack_public_path__ + "img/PrinterUnconnected.fc245467.svg";